"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewSiteGroup extends new_item_1.default {
    constructor(newSiteGroup) {
        super();
        this.name = newSiteGroup.name;
        this.dataTypes = newSiteGroup.dataTypes;
        this.widgetBoardId = newSiteGroup.widgetBoardId;
        this.totalDemand = newSiteGroup.totalDemand;
        this.issueIds = newSiteGroup.issueIds;
        this.siteIds = newSiteGroup.siteIds;
        this.disconnectedAssetsViaHub = newSiteGroup.disconnectedAssetsViaHub;
        this.issues = newSiteGroup.issues;
        this.appliances = newSiteGroup.appliances;
        this.lowBatteryAssets = newSiteGroup.lowBatteryAssets;
        this.lowSignalAssets = newSiteGroup.lowSignalAssets;
        this.assetsWithIssues = newSiteGroup.assetsWithIssues;
        this.faultyAssets = newSiteGroup.faultyAssets;
        this.intermittentAssets = newSiteGroup.intermittentAssets;
        this.anomalousAssets = newSiteGroup.anomalousAssets;
        this._permission = newSiteGroup._permission;
    }
}
exports.default = NewSiteGroup;
//# sourceMappingURL=new-siteGroup.js.map